import { Component } from '@angular/core';

@Component({
    selector: 'btl-modal-cms',
    templateUrl: './modal-cms.component.html',
    styleUrls: ['./modal-cms.component.scss'],
})
export class ModalCmsComponent {
    public blockId: string;
    public isLoading: boolean = true;

    public initCmsBlock(cmsBlock: string) {
        this.blockId = cmsBlock;
    }

    public contentLoad(load: boolean) {
        this.isLoading = !load;
    }
}
